import protectedComponent from 'components/helpers/protectedComponent';

import action from 'common/rbac/actions';

export default protectedComponent(() => import('./refractoryPanelDisclaimer'), {
  action: action.TECH_VIEW,
});
